import React, { Component } from "react";

class Notification extends Component {
 constructor(props) {
    super(props);
    this.state = {
      display: this.props.display,
      lang: this.props.lang
    }
  }

  componentDidMount() {
    const {dynamic} = this.props;
    if (dynamic) {
      const { display } = this.props;
      return this.setState({ display });
    } else {
      return this.setState({ display: true });
    }
  }

  render() {
    const { lang, display } = this.state;
    const {dynamic} = this.props;
    const follow = {
      cat: "Segueix-nos a Instagram!",
      cas: "Síguenos en Instagram!",
      en: "Follow us on Instagram!",
      fr: "Suis nous sur instagram!",
      de: "Folge uns auf Instagram!"
    }
    const style = "rounded-xl text-center m-auto bg-white relative w-80 top-10 py-10";
    
    return (
      <div className={display ? style : "hide"}>
        {dynamic ?           
          <div className="absolute top-0 right-0 bg-gray-300 text-white w-10 h-10 " onClick={() => this.props.hideNotification()}>
            <h1 className="rounded-3xl"><span>x</span></h1>
        </div>
        : ""
        }
        <p className="text-4xl">{follow[lang]}</p>
        <div className="flex justify-center items-center mt-5">
          <a href="https://www.instagram.com/max_and_sax/" target="_blank" rel="noreferrer" className="w-1/5 mr-3"><img src="../Instagram_logo_2016.svg.png" alt="instagram logo" /></a>
          <a href="https://www.instagram.com/max_and_sax/" target="_blank" rel="noreferrer">@max_and_sax</a>
          </div>
      </div>
    )
  }
}

export default Notification;